/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelPageSlot64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelPageSlot64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              d="M16 44.5V43.55H17V44H17.4688V45H16.5C16.2239 45 16 44.7761 16 44.5Z"
              fill="currentColor"
            />
            <path d="M16 41.65V39.75H17V41.65H16Z" fill="currentColor" />
            <path d="M16 37.85V35.95H17V37.85H16Z" fill="currentColor" />
            <path d="M16 34.05V32.15H17V34.05H16Z" fill="currentColor" />
            <path d="M16 30.25V28.35H17V30.25H16Z" fill="currentColor" />
            <path
              d="M16 26.45V25.5C16 25.2239 16.2239 25 16.5 25H17.4688V26H17V26.45H16Z"
              fill="currentColor"
            />
            <path d="M19.4062 25H21.3438V26H19.4062V25Z" fill="currentColor" />
            <path d="M23.2812 25H25.2188V26H23.2812V25Z" fill="currentColor" />
            <path d="M27.1562 25H29.0938V26H27.1562V25Z" fill="currentColor" />
            <path d="M31.0312 25H32.9688V26H31.0312V25Z" fill="currentColor" />
            <path d="M34.9062 25H36.8438V26H34.9062V25Z" fill="currentColor" />
            <path d="M38.7812 25H40.7188V26H38.7812V25Z" fill="currentColor" />
            <path d="M42.6562 25H44.5938V26H42.6562V25Z" fill="currentColor" />
            <path
              d="M46.5312 25H47.5C47.7761 25 48 25.2239 48 25.5V26.45H47V26H46.5312V25Z"
              fill="currentColor"
            />
            <path d="M48 28.35V30.25H47V28.35H48Z" fill="currentColor" />
            <path d="M48 32.15V34.05H47V32.15H48Z" fill="currentColor" />
            <path d="M48 35.95V37.85H47V35.95H48Z" fill="currentColor" />
            <path d="M48 39.75V41.65H47V39.75H48Z" fill="currentColor" />
            <path
              d="M48 43.55V44.5C48 44.7761 47.7761 45 47.5 45H46.5312V44H47V43.55H48Z"
              fill="currentColor"
            />
            <path d="M44.5938 45H42.6562V44H44.5938V45Z" fill="currentColor" />
            <path d="M40.7188 45H38.7812V44H40.7188V45Z" fill="currentColor" />
            <path d="M36.8438 45H34.9062V44H36.8438V45Z" fill="currentColor" />
            <path d="M32.9688 45H31.0312V44H32.9688V45Z" fill="currentColor" />
            <path d="M29.0938 45H27.1562V44H29.0938V45Z" fill="currentColor" />
            <path d="M25.2188 45H23.2812V44H25.2188V45Z" fill="currentColor" />
            <path d="M21.3438 45H19.4062V44H21.3438V45Z" fill="currentColor" />
            <path
              d="M31.5 40V35.5H27V34.5H31.5V30H32.5V34.5H37V35.5H32.5V40H31.5Z"
              fill="currentColor"
            />
          </g>
          <g opacity="0.2">
            <path
              d="M16 16.5C16 14.567 17.567 13 19.5 13H36.7071L47.8536 24.1464L47.1464 24.8536L36.2929 14H19.5C18.1193 14 17 15.1193 17 16.5V25H16V16.5Z"
              fill="currentColor"
            />
            <path
              d="M17 45V47.5C17 48.8807 18.1193 50 19.5 50H44.5C45.8807 50 47 48.8807 47 47.5V45H48V47.5C48 49.433 46.433 51 44.5 51H19.5C17.567 51 16 49.433 16 47.5V45H17Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelPageSlot64Icon.tags = ['add', 'file', 'page', 'new', 'document'];

AddPanelPageSlot64Icon.category = '64x64 (Add panel)';

AddPanelPageSlot64Icon.iconSize = 64;
